import { render, staticRenderFns } from "./ReferralAgentCard.vue?vue&type=template&id=40301a81&scoped=true"
import script from "./ReferralAgentCard.vue?vue&type=script&lang=js"
export * from "./ReferralAgentCard.vue?vue&type=script&lang=js"
import style0 from "./ReferralAgentCard.vue?vue&type=style&index=0&id=40301a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40301a81",
  null
  
)

export default component.exports